var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-md-block d-sm-none",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.content.columnId && _vm.content.columnId[_vm.$i18n.locale]
            ? _vm.content.columnId[_vm.$i18n.locale].current
            : _vm.content._key}},[_c('div',{staticStyle:{"height":"100%"},style:(_vm.calcImageInlineStyle())},[_vm._v(" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }